import React from "react";
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from "react-leaflet";
import L from "leaflet";

const icon = L.icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34], shadowSize: [41, 41],
});

const RIYADH = [24.7136, 46.6753];

function ClickCapture({ onPick }) {
  useMapEvents({ click(e) { onPick(Number(e.latlng.lat.toFixed(6)), Number(e.latlng.lng.toFixed(6))); } });
  return null;
}

export function MapPicker({ lat, lng, onPick, height = 240 }) {
  const center = lat && lng ? [lat, lng] : RIYADH;
  return (
    <div className="overflow-hidden rounded-xl border border-border" data-testid="map-picker">
      <MapContainer center={center} zoom={12} style={{ height }} scrollWheelZoom={false}>
        <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <ClickCapture onPick={onPick} />
        {lat && lng && <Marker position={[lat, lng]} icon={icon} />}
      </MapContainer>
    </div>
  );
}

export function BranchMap({ branches, isAr, height = 420 }) {
  const withGeo = branches.filter((b) => b.lat && b.lng);
  const center = withGeo.length ? [withGeo[0].lat, withGeo[0].lng] : RIYADH;
  return (
    <div className="overflow-hidden rounded-3xl border border-border shadow-sm" data-testid="branch-map">
      <MapContainer center={center} zoom={withGeo.length ? 6 : 11} style={{ height }} scrollWheelZoom={true}>
        <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {withGeo.map((b) => (
          <Marker key={b.id} position={[b.lat, b.lng]} icon={icon}>
            <Popup>
              <div className="text-sm font-bold">{isAr ? b.name_ar : b.name_en}</div>
              <div className="text-xs text-slate-500">{isAr ? b.city_ar : b.city_en}</div>
              <a href={`https://www.google.com/maps/dir/?api=1&destination=${b.lat},${b.lng}`} target="_blank" rel="noreferrer" className="mt-1 inline-block text-xs font-semibold text-blue-600">
                {isAr ? "الاتجاهات ←" : "Directions →"}
              </a>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
